var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHamburgerIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#072C54",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M3.5 5h17M3.5 12h17M3.5 19h17"
})));
export { SvgHamburgerIcon as ReactComponent };
export default "/_next/static/images/hamburger-icon.svg";